<template>
  <div id="appNavbar" class="p-4 bg-blue-50">
    <div class="grid grid-cols-2 gap-4">
      <template v-for="(item, index) in $route.meta.menu" :key="`menu1-${index}`">
        <router-link class="bg-white text-primary p-4 text-sm md:block" :class="[item.className]"
          :to="{ name: item.route }" @click="$emit('close-nav')">{{ item.title }}</router-link>
      </template>

      <a v-if="$route.meta?.actions?.share" class="bg-white text-primary p-4 md:block" @click="share(); $emit('close-nav')"><i
          class="fas fa-share-nodes mr-1" />Share
      </a>
      <router-link v-show="isUserAuthenticated" class="bg-white text-primary p-4 text-sm" :to="{ name: 'Profile' }" @click="$emit('close-nav')"><i
          class="fas fa-user mr-1"></i>
        Profile</router-link>

      <a
        v-show="isUserAuthenticated"
        class="bg-white text-primary p-4 text-sm md:block cursor-pointer"
        @click="showQRCode()"
      >
        <i class="fas fa-qrcode mr-1"></i>
        My QR Code
      </a>

      <router-link class="bg-white text-primary p-4 text-sm md:block" :to="{ name: 'About' }" @click="$emit('close-nav')"><i
          class="fas fa-circle-info mr-1"></i>About</router-link>


      <router-link v-show="isUserAuthenticated" @click="$emit('close-nav')"
        class="bg-white text-primary p-4 text-sm md:block" :to="{ name: 'SignOut' }"><i
          class="fas fa-right-from-bracket mr-1"></i> Sign Out</router-link>
    </div>
  </div>

  <!-- QR Code Modal -->
  <UserQRCode
    ref="userQRCodeRef"
    @modal-opened="$emit('qr-modal-opened')"
    @modal-closed="handleQRModalClosed"
  />
</template>

<script setup lang="ts">
import { useUserProfileStore } from "@/store/UserProfile";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useRoute } from "vue-router";
import Config from "@/config/Config";
import UserQRCode from "@/components/UserQRCode.vue";

const { isUserAuthenticated } = storeToRefs(useUserProfileStore());

const route = useRoute();
const userQRCodeRef = ref<InstanceType<typeof UserQRCode> | null>(null);

const emit = defineEmits(['close-nav', 'qr-modal-opened', 'qr-modal-closed']);

const showQRCode = () => {
  userQRCodeRef.value?.toggleShowModal();
};

const handleQRModalClosed = () => {
  emit('close-nav');
};

const share = () => {
  const data = {
    url: `${Config.LinkUrl}${route.path}`,
  };
  window.navigator.share(data);
};
</script>
